<div class=" chat-bot pb-md-5 my-md-3 " id="chatbot" [ngClass]="{'arabic': lang === 'ar','no-en': langs()}" >
  <div class="container">

    <div class="row align-items-center justify-content-center"  >
      <div class="col-lg-8  order-2 order-xl-1">
        <div class="row align-items-center ">
          <div class="col-lg-12">
            <div class="text-center text-lg-start mx-auto mt-5 mt-md-0">
              <h2 class=" fw-semibold mb-md-5 mb-3 font-48 text-center text-blue">
                {{"chat-head"|translate}}
                </h2>
                <!-- <p class="first_paragraph fw-regular font-16 text-dark-blue pb-5 mb-4 pt-3">
                  {{"chat-para"|translate}}
                </p> -->
             </div>
          </div>
        </div>
        <div class="row ">
          <div class="col-md-4 mb-17" *ngFor="let item of items">
            <div class="buy-box text-center">
              <div class="mb-3 pb-1">
                <svg-icon  src="{{item.icon}}" [svgStyle]="{ 'width.px':50,'height.px':50}"></svg-icon>
              </div>
              <div>
                <h3 class="fw-semibold font-20 mb-2 text-blue">{{item.head | translate}}</h3>
                <p class="font-16 fw-medium mb-0 text-light px-0 ">{{item.para |  translate}}
                </p> 
             </div>
            </div>
          </div>
          </div>
        </div>
      <div class="col-lg-3 order-1 order-xl-2 text-center text-lg-end token-wrap">
        <img src="./assets/images/new/chatright.svg"  class="img-fluid mb-3 my-lg-5 chat-mockup" alt="">
      </div>
    </div>
  </div>
